const getIconModules = () => {
  // @ts-ignore
  return import.meta.glob("./icons/*.svg", {
    eager: true,
    query: "?url",
    import: "default",
  }) as Record<string, string>;
};

let iconModules: Record<string, string> = {};
try {
  iconModules = getIconModules();
} catch (e) {
  // Fallback for tests
}

export const getIconUrl = (name: string) => {
  const key = Object.keys(iconModules).find((k) => k.endsWith(`/${name}.svg`));
  return key ? iconModules[key] : "";
};
